const views = {
  monthly: 'monthly',
  daily: 'daily'
}

export const viewOptions = [
  {
    value: views.monthly,
    label: 'Month'
  },
  {
    value: views.daily,
    label: 'Day'
  }
]

export default views
